// extracted by mini-css-extract-plugin
export default {"linkElement":"LinkComponent_linkElement__C4aEz"};